export const showDuration = (duration: number, showEmpty = true) => {
  if (duration === 0) return showEmpty ? "-" : "";
  if (duration < 60) return `${duration} сек`;
  const min = Math.floor(duration / 60);
  const sec = duration % 60;
  return `${min} мин ${sec} сек`;
};
